<template>
  <router-link
    :to="{ name: this.routeName }"
    :style="useStyle ? style : ''"
    :disabled="disabled">
    <slot/>
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'LinkIntern',
    props: {
      routeName: String,
      disabled: Boolean,
      useStyle: {
        default: true,
        type: Boolean,
        required: false,
      },
    },
    computed: {
      ...mapGetters('user', ['mainColors']),
      style() {
        const {
          r, g, b, a,
        } = this.mainColors.text.rgba;
        return `color: rgba(${r}, ${g}, ${b}, ${a});`;
      },
    },
  };
</script>
